<template>
    <div>
        <b-container fluid>
            <b-row align-h="between" align-v="center">
                <b-col class="col-6" sm="6" md="6" lg="6" align-self="center">
                    <b-img v-show="place_public_data" :src="place_public_data" style="max-width: 25vw;height: auto;max-height: 20vh;width: auto;"> </b-img>
                </b-col>

                <b-col class="col-6" sm="6" md="6" lg="6" align-self="center">
                    <p class="h1">Relatório de Arrecadação - {{ userName }}</p>
                </b-col>
            </b-row>
            <br>

            <b-row align-h="between" align-v="center" class="py-4">
                <b-col class="col-8" sm="8" md="8" lg="8" align-self="center">
                    <b-card class="subcard-p-3">
                        <h3 class="card-title mb-0">Reservas pagas e com check-in entre
                            {{ formattedStartDate + ' e ' + formattedEndDate }} - {{ dateDiff > 1 ? dateDiff + " dias" :
                                dateDiff + " dia" }}</h3>
                        <p class="text-normal d-inline">Gerado em {{ dateTimeNow }} por {{ userName }}</p>
                        <br>
                        <p class="text-normal d-inline"> <b>{{ city }}</b> </p>
                    </b-card>
                </b-col>


                <b-col class="col-4" sm="4" md="4" lg="4" align-self="center">
                    <b-card class="subcard-p-3">
                        <!-- <h3 class="card-title mb-0">Saldo</h3> -->
                        <b-row align-h="between">
                            <b-col cols="6">
                                <p class="text-normal d-inline">Pessoas:</p>
                            </b-col>
                            <b-col cols="6">
                                <p class="text-normal d-inline"> <b>{{ numVisitantes }}</b> </p>
                            </b-col>
                        </b-row>

                        <b-row align-h="between">
                            <b-col cols="6">
                                <p class="text-normal d-inline">Pagantes:</p>
                            </b-col>
                            <b-col cols="6">
                                <p class="text-normal d-inline"> <b>{{ numPagantes }}</b> </p>
                            </b-col>
                        </b-row>

                        <b-row align-h="between">
                            <b-col cols="6">
                                <p class="text-normal d-inline">Saldo:</p>
                            </b-col>
                            <b-col cols="6">
                                <p class="text-normal d-inline"> <b>{{ 'R$ ' + formattedSaldo }}</b> </p>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>

<script>
import moment from "moment"
import { mapGetters } from 'vuex'

export default {
    component: "HeaderRelatorio",

    props: {
        numVisitantes: {
            default: 0,
            type: Number,
        },

        numPagantes: {
            default: 0,
            type: Number,
        },

        startDate: {
            default: "",
            type: String
        },

        endDate: {
            default: "",
            type: String
        },

        saldoTotal: {
            default: 0,
            type: Number
        }
    },

    computed: {
        ...mapGetters('auth', {
            user: 'user',
        }),

        dateTimeNow() { return moment().format("DD/MM/YYYY HH:mm"); },

        dateDiff() { return moment(this.endDate).diff(moment(this.startDate), 'days') + 1 },

        formattedStartDate() { return moment(this.startDate).format("DD/MM/YYYY"); },

        formattedEndDate() { return moment(this.endDate).format("DD/MM/YYYY"); },

        userName() { return this.user.name },

        city() { return this.user.placeName },

        formattedSaldo() { return (this.saldoTotal).toFixed(2).replace('.', ',') }
    },

    data: () => {
        return {
            place_public_data: ''
        }
    },

    created(){
      this.place_public_data = require('@/assets/img/janoo-logo.png')
    },

    mounted(){
    },

}
</script>
